import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { FadeUp, Overline } from "@/components/motion";
import { useContent } from "@/lib/content";

const IMG = "/images/hero.jpg";

export default function Manifesto() {
  const c = useContent();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="hotel" ref={ref} className="py-24 lg:py-36 bg-sand" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <FadeUp>
            <Overline>{c.manifesto_overline}</Overline>
            <h2 className="mt-4 font-serif font-medium text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-forest">
              {c.manifesto_title_1} <em className="italic text-terra">{c.manifesto_title_2}</em>
            </h2>
          </FadeUp>
          <FadeUp delay={0.15} className="mt-8 space-y-5 text-base leading-relaxed text-ink/70">
            <p>{c.manifesto_text_1}</p>
            <p>{c.manifesto_text_2}</p>
          </FadeUp>
          <FadeUp delay={0.25} className="mt-10 grid grid-cols-3 gap-6">
            {[
              ["30", "Zimmer & Suiten"],
              ["4 Min.", "zum Nonnenturm"],
              ["10 Min.", "zu den Wildpferden"],
            ].map(([n, l]) => (
              <div key={l}>
                <p className="font-serif text-3xl sm:text-4xl font-semibold text-forest">{n}</p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-ink/50">{l}</p>
              </div>
            ))}
          </FadeUp>
        </div>

        <FadeUp delay={0.2} className="lg:col-span-7">
          <div className="relative overflow-hidden rounded-3xl aspect-[4/3] shadow-2xl shadow-forest/20">
            <motion.img
              src={c.manifesto_image || IMG}
              alt="Wandbild eines Wildpferds im Hotel Wildpferd Dülmen"
              style={{ y: imgY }}
              className="absolute inset-0 w-full h-[116%] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-forest-dark/50 to-transparent" />
            <p className="absolute bottom-6 left-6 right-6 font-serif italic text-xl sm:text-2xl text-sand">
              {c.manifesto_quote}
            </p>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
